/** @file The value a field starts from when neither the prefill nor the schema gives one. */
import type { FieldSpec } from './schemaFields';

type Leaf = Exclude<FieldSpec, { kind: 'group' }>;

const NEUTRAL: { [K in Leaf['kind']]: (f: Extract<Leaf, { kind: K }>) => unknown } = {
  number: (f) => f.min ?? 0,
  text: () => '',
  flag: () => false,
  choice: (f) => f.options[0] ?? '',
  color: (f) => (f.alpha ? '#ffffffff' : '#000000'),
  vector: (f) => new Array<number>(f.size).fill(0),
  ref: () => '',
  json: () => '',
};

/** Neutral start value of a field; a group starts present (`true`). */
export function neutralValue(field: FieldSpec): unknown {
  if (field.kind === 'group') return true;
  return (NEUTRAL[field.kind] as (f: Leaf) => unknown)(field);
}
